export default __webpack_public_path__ + "static/media/qb-logo.cc246289.svg";